module.exports = __webpack_public_path__ + "images/home-dingtalk-work/howto_2-de3dcf961f3a88f4e6e144b7ed7123d8.png";